import { EcommerceAPI } from "../Client";

export const getOfferingAPI = async (id) => {
  try {
    const response = await EcommerceAPI.get(`/offering?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const createOfferingAPI = async (payload) => {
  try {
    const response = await EcommerceAPI.post("/offering", payload);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateOfferingAPI = async (payload) => {
  try {
    const response = await EcommerceAPI.put("/offering", payload);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteOfferingAPI = async (id) => {
  try {
    const response = await EcommerceAPI.delete(`/offering?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateOfferingStatusAPI = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/offering/status?id=${payload?.id || ""}&isActive=${payload?.isActive ?? ""}`
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getAllOfferingAPI = async (params = {}) => {
  try {
    const query = new URLSearchParams();

    if (params?.page !== undefined && params?.page !== null) {
      query.append("page", params.page);
    }

    if (params?.size !== undefined && params?.size !== null) {
      query.append("size", params.size);
    }

    if (params?.sortBy) {
      query.append("sortBy", params.sortBy);
    }

    if (params?.sortDir) {
      query.append("sortDir", params.sortDir);
    }

    const response = await EcommerceAPI.get(`/offering/all${query.toString() ? `?${query.toString()}` : ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const uploadOfferingFilesAPI = async (payload = {}) => {
  try {
    const formData = new FormData();

    (payload?.files || []).forEach((file) => {
      formData.append("files", file);
    });

    const response = await EcommerceAPI.post("/offering/upload/files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteOfferingFileAPI = async (uploadId) => {
  try {
    const response = await EcommerceAPI.delete(`/offering/file?uploadId=${uploadId || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getOfferingBookingsAPI = async () => {
  try {
    const response = await EcommerceAPI.get("/offering/booking");
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const createOfferingBookingAPI = async (payload) => {
  try {
    const response = await EcommerceAPI.post("/offering/booking", payload);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getOfferingBookingByIdAPI = async (bookingId) => {
  try {
    const response = await EcommerceAPI.get(`/offering/booking/${bookingId || 0}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getSellerOfferingBookingsAPI = async (params = {}) => {
  try {
    const query = new URLSearchParams();

    if (params?.page !== undefined && params?.page !== null) {
      query.append("page", params.page);
    }

    if (params?.size !== undefined && params?.size !== null) {
      query.append("size", params.size);
    }

    if (params?.sortBy) {
      query.append("sortBy", params.sortBy);
    }

    if (params?.placedOn) {
      query.append("placedOn", params.placedOn);
    }

    if (params?.sortDir) {
      query.append("sortDir", params.sortDir);
    }

    if (params?.search) {
      query.append("search", params.search);
    }

    const response = await EcommerceAPI.get(
      `/offering/booking/seller${query.toString() ? `?${query.toString()}` : ""}`
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
